import { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { ProviderType } from "../../lib/types";
import { Badge } from "../ui/badge";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "../ui/table";
import { ProviderDialog } from "./ProviderDialog";
import { ProviderMarginDialog } from "./ProviderMarginDialog";

export const ProviderTable = () => {
  const [providers, setProviders] = useState<ProviderType[]>([]);
  const [searchFilter, setSearchFilter] = useState("");
  const [isDialogOpen, setIsDialogOpen] = useState(false); // Renamed from isAddOpen
  const [isMarginDialogOpen, setIsMarginDialogOpen] = useState(false);
  const [selectedProvider, setSelectedProvider] = useState<ProviderType | null>(null);

  const fetchProviders = async () => {
    try {
      const result = await api.getProviders();
      setProviders(result || []);
    } catch (error) {
      console.error("Failed to fetch providers:", error);
    }
  };

  useEffect(() => {
    fetchProviders();
  }, []);

  const filteredProviders = providers.filter(provider =>
    provider.name.toLowerCase().includes(searchFilter.toLowerCase()) ||
    provider.code.toLowerCase().includes(searchFilter.toLowerCase())
  );

  return (
    <div className="space-y-4 min-h-screen bg-white dark:bg-gray-900 p-6">
      <div className="flex justify-between items-center">
        <h1 className="text-2xl font-bold dark:text-white">Providers</h1>
        <Button
          onClick={() => {
            setIsDialogOpen(true); // Changed from setIsAddOpen
          }}
        >
          Add Provider
        </Button>
      </div>

      <div className="flex justify-between items-center">
        <div className="flex space-x-2">
          <Input
            type="text"
            placeholder="Search Provider"
            className="w-64 dark:bg-gray-800 dark:text-white dark:border-gray-700"
            value={searchFilter}
            onChange={e => setSearchFilter(e.target.value)}
          />
        </div>
      </div>

      <div className="rounded-md border dark:border-gray-700">
        <Table>
          <TableHeader>
            <TableRow className="dark:border-gray-700 dark:bg-gray-800">
              <TableHead className="dark:text-gray-400">Name</TableHead>
              <TableHead className="dark:text-gray-400">Code</TableHead>
              <TableHead className="dark:text-gray-400">Type</TableHead>
              <TableHead className="dark:text-gray-400">Actions</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {filteredProviders.map(provider => (
              <TableRow
                key={provider.id}
                className="dark:hover:bg-gray-700 dark:border-gray-700 dark:bg-gray-800"
              >
                <TableCell className="dark:text-gray-300">
                  {provider.name}
                </TableCell>
                <TableCell className="dark:text-gray-300">
                  {provider.code}
                </TableCell>
                <TableCell className="dark:text-gray-300">
                  <Badge variant="outline" className="capitalize">
                    {provider.type}
                  </Badge>
                </TableCell>
                <TableCell className="dark:text-gray-300">
                  <Button
                    variant="outline"
                    size="sm"
                    onClick={() => {
                      setSelectedProvider(provider);
                      setIsMarginDialogOpen(true);
                    }}
                  >
                    Margins
                  </Button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>

      <ProviderDialog
        open={isDialogOpen} // Changed from isAddOpen
        onOpenChange={setIsDialogOpen} // Changed from setIsAddOpen
        onSave={fetchProviders}
      />

      <ProviderMarginDialog
        open={isMarginDialogOpen}
        onOpenChange={setIsMarginDialogOpen}
        provider={selectedProvider}
      />
    </div>
  );
};
